export default {"src":"/_next/static/media/minus-product.115cecd9.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};